import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Settings.css';

const Settings = () => {
  const navigate = useNavigate();
  const { user, api } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  
  const [formData, setFormData] = useState({
    username: user?.username || '',
    email: user?.email || '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 这里可以调用更新用户信息的API
      // await api.put('/api/auth/update-profile', formData);
      
      setSuccess('设置已保存成功！');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || '保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-card">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← 返回
        </button>

        <h2 className="settings-title">账户设置</h2>

        {error && <div className="settings-error">{error}</div>}
        {success && <div className="settings-success">{success}</div>}

        <form onSubmit={handleSubmit} className="settings-form">
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="请输入用户名"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">邮箱地址</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="请输入邮箱地址"
              disabled
            />
            <small className="form-hint">邮箱地址不可修改</small>
          </div>

          <button 
            type="submit" 
            className="settings-btn"
            disabled={loading}
          >
            {loading ? '保存中...' : '保存设置'}
          </button>
        </form>

        <div className="settings-section">
          <h3 className="section-title">安全设置</h3>
          <div className="security-options">
            <button 
              className="security-btn"
              onClick={() => navigate('/change-password')}
            >
              <span className="btn-icon">🔐</span>
              <div className="btn-content">
                <div className="btn-title">修改密码</div>
                <div className="btn-desc">定期修改密码可以提高账户安全性</div>
              </div>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>

        <div className="settings-section">
          <h3 className="section-title">通知设置</h3>
          <div className="notification-options">
            <label className="toggle-option">
              <span>接收邮件通知</span>
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider"></span>
            </label>
            <label className="toggle-option">
              <span>接收系统通知</span>
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
